const config = {
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
};

export default config;
